declare global {
  interface Window {
    chrome: any;
    webkit: any;
    hybridWebViewHost: {
      sendMessage: (message: string) => void;
    };
  }
}
export default class HybridWebView {
  static readonly SendRawMessageToDotNet = function (message) {
    HybridWebView.SendMessageToDotNet(0, message);
  };

  static readonly SendInvokeMessageToDotNet = function (methodName, paramValues) {
    if (typeof paramValues !== 'undefined') {
      if (!Array.isArray(paramValues)) {
        paramValues = [paramValues];
      }
      for (let i = 0; i < paramValues.length; i++) {
        paramValues[i] = JSON.stringify(paramValues[i]);
      }
    }
    HybridWebView.SendMessageToDotNet(
      1,
      JSON.stringify({ MethodName: methodName, ParamValues: paramValues })
    );
  };

  static readonly SendMessageToDotNet = function (messageType, messageContent) {
    const message = JSON.stringify({ MessageType: messageType, MessageContent: messageContent });
    if (window.chrome?.webview) {
      // Windows WebView2
      window.chrome.webview.postMessage(message);
    } else if (window.webkit?.messageHandlers?.webwindowinterop) {
      // iOS and MacCatalyst WKWebView
      window.webkit.messageHandlers.webwindowinterop.postMessage(message);
    } else {
      // Android WebView
      window.hybridWebViewHost?.sendMessage(message);
    }
  };
}
